// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "hr[data-v-2f029f00] {\n  width: 100%;\n}\n.page-header[data-v-2f029f00] {\n  margin: 0;\n}\n.page-header h1[data-v-2f029f00] {\n  font-size: 36px;\n}", ""]);
// Exports
module.exports = exports;
